import { cn } from 'utils/shadcn';

export const BetaBadge = ({ className }: { className?: string }) => {
  return (
    <span
      className={cn(
        'text-[10px] text-neutral-50 bg-brand/90 rounded-full px-2 py-0.5',
        className
      )}
    >
      Beta
    </span>
  );
};
